function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "11",
  viewBox: "0 0 18 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 2.804H9.09V5.15h7.41V2.804z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.775 7.997c-.685 0-1.25.502-1.33 1.146h2.659c-.08-.644-.645-1.146-1.33-1.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v9.143h.789c.083-1.175 1.09-2.106 2.32-2.106.745 0 1.406.343 1.833.874a2.347 2.347 0 011.832-.874c1.23 0 2.237.931 2.32 2.106h1.727V0H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.109 7.997c-.685 0-1.25.502-1.33 1.146h2.659a1.329 1.329 0 00-1.33-1.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.09 5.922v3.219h1.82c.138-1.12 1.12-1.993 2.308-1.993 1.19 0 2.172.872 2.309 1.993h.973V5.922H9.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.218 8.108c-.643 0-1.182.443-1.31 1.033h2.62a1.33 1.33 0 00-1.31-1.033z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.109 10.89c.877 0 1.587-.69 1.587-1.542 0-.852-.71-1.543-1.587-1.543s-1.588.69-1.588 1.543c0 .852.711 1.542 1.588 1.542z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.774 10.89c.877 0 1.588-.69 1.588-1.542 0-.852-.71-1.543-1.588-1.543-.876 0-1.587.69-1.587 1.543 0 .852.71 1.542 1.587 1.542z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.218 11c.877 0 1.588-.69 1.588-1.543 0-.852-.711-1.542-1.588-1.542-.876 0-1.587.69-1.587 1.542 0 .852.71 1.543 1.587 1.543z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17.417v11H0z"
})))));